var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFlood({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.576,
    height: 42.245,
    viewBox: "0 0 48.576 42.245",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1066",
    "data-name": "Grupo 1066",
    transform: "translate(-2624.668 7398.956)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7304",
    "data-name": "Trazado 7304",
    d: "M2625.723-7359.168s12.177-.681,16.176-3.336c0,0,5.191,7.281,14.879,1.259,0,0,8.408,6.27,15.067,1.274",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7305",
    "data-name": "Trazado 7305",
    d: "M2634.964-7360.271l-2.807-7.627,36.492,3.814-2.917,6.039",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7306",
    "data-name": "Trazado 7306",
    d: "M2654.113-7388.184l-3,19.268s8.839-3.159,12.545,0Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7307",
    "data-name": "Trazado 7307",
    d: "M2651.112-7397.955l-3.656,26.885s-7.5-6.44-12.168-3.055Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlood);
export default __webpack_public_path__ + "static/media/flood.34828efb.svg";
export { ForwardRef as ReactComponent };